import React from 'react'
import './textareas.css'

const BaseTextarea = ({ text, callback }) => {
    return (
        <div className='base-textarea-container'>
            <label className='base-textarea-label'>{text}</label>
            <textarea className='base-textarea' onChange={callback} />
        </div>
    )

}

export {
    BaseTextarea
}